import React, { useEffect, useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { betHistoryService } from "../../services/BetSlip/BetHistoryService";
import { appStore } from "../../stores/appStore";
import InfoMessages from "../InfoMessage/InfoMessage";
import Loader from "../ui-components/Loader";
import BetSlipList from "./BetSlipList";
import { sessionService } from "../../services/Session/SessionService";
import { useTranslation } from "react-i18next";
import { StyledHistoryBottom, StyledHistoryHead } from "./BetHistoryStyle";
import { B2BResize } from "../../services/common/globalFunctions";

const BetHistory = () => {
  const [collapse, setCollaps] = useState(false);
  const [selectIndex, setSelectIndex] = useState(0);
  const [betHistory, setBetHistory] = useState([]);
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [showLoader, setShowLoader] = useState(false);
  const [loadMoreShow, setLoadMoreShow] = useState(true);

  const { t } = useTranslation("General");

  const { currentLeague, playerId, leaguesList, leagueName } = appStore((state) => ({
    currentLeague: state.currentLeague,
    playerId: state.playerId,
    leaguesList: state.leaguesList,
    leagueName: state.leagueName
  }));
  let userSession = sessionService.getUserSession();

  useEffect(() => {
    const getBetHistoryList = async () => {
      if (currentPageNo === 1) {
        setShowLoader(true);
      }
      // const rgsSession = await sessionService.getRGSSession();
      const response = await betHistoryService.getBetHistoryList(
        playerId,
        currentPageNo
      );
      let data = response.data;
      if (data.length === 0 || data.length < 5) {
        setLoadMoreShow(false);
      } else {
        setLoadMoreShow(true);
      }
      if (currentPageNo === 1) {
        setBetHistory(data);
        setShowLoader(false);
      } else {
        for (var betData of data) {
          betHistory.push(betData);
        }
        setShowLoader(false);
      }
      setTimeout(() => {
        B2BResize("Bethistory Page");
      }, 500);
    };
    if(userSession.token){
      getBetHistoryList();
    }
  }, [currentPageNo]);

  const nextHistory = () => {
    if (currentPageNo >= 0) {
      setCurrentPageNo(currentPageNo + 1);
    }
  };

  const collapseIcon = (index) => {
    setSelectIndex(index);
    if (!collapse) {
      setCollaps(true);
    } else {
      if (selectIndex === index) {
        setCollaps(false);
      } else {
        setCollaps(true);
      }
    }
  };
  const getResult = (id) => {
    for (var league of leaguesList) {
      if (league?.leagueId == id) {
        const leagueDisplayName = leagueName && leagueName?.leaguePrefix ? leagueName?.leaguePrefix + league?.leagueName?.split("-")[1] : league?.leagueName;
        return leagueDisplayName
      }
    }
  };
  return showLoader ? (
    <Loader />
  ) : (
    <React.Fragment>
      {betHistory.length === 0 ? (
        <InfoMessages messages={<div>{t("No History Found")}</div>} />
      ) : (
        <React.Fragment>
          <div className="text-dark mx-3 mb-2 fw-bold">
            {betHistory?.map((history, index) => (
              <div key={index} className="mb-3 rounded-3 border border-info">
                <StyledHistoryHead
                  className="d-flex justify-content-between align-items-center rounded-top p-2 bg-primary text-white cursor"
                  onClick={(e) => collapseIcon(index)}
                >
                  <div className="d-flex justify-content-center justify-items-center">
                    <span className="me-2">
                      {collapse && index === selectIndex ? (
                        <FaChevronUp size="13px" />
                      ) : (
                        <FaChevronDown size="13px" />
                      )}
                    </span>
                    <span>
                      {history.selections.length > 1 ? (
                        <span>{t("Combo")}</span>
                      ) : history.betType === "SUPER_ODDS" ?
                        (<span>{t("Super Odds")}</span>) :
                        (
                          <span>{t("Single")}</span>
                        )}
                    </span>
                  </div>
                  <div>
                    <span
                      className={`p-1 rounded card-footer 
                         ${history.status ===
                          "SETTLED" ||
                          history.status === "WON"
                          ? "bg-success text-white"
                          : history.status ===
                            "OPEN" ||
                            history.status ===
                            "PLACED"
                            ? "bg-warning text-dark"
                            : "bg-secondary text-white"
                        }`}
                    >
                      {history.status === "SETTLED"
                        ? "WON"
                        : history.status === "PLACED"
                          ? "OPEN"
                          : t(`${history.status}`)}
                    </span>
                  </div>
                </StyledHistoryHead>
                <div className="d-flex justify-content-between align-items-center text-black">
                  <div className="flex-grow-1">
                    <div className="pt-2 px-2">
                      <div className="d-flex justify-content-between align-items-center">
                        <h6 className="fw-normal ">{t("Bet ID")} :</h6>
                        <h6 className="text-truncate w-50 text-end">
                          {history?.rgsSession?.roundId}
                        </h6>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <h6 className="fw-normal ">{"PlacedAt"} :</h6>
                        <h6 className="text-truncate w-50 text-end">
                          {new Date(history.placedAt).toLocaleString()}
                        </h6>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <h6 className="fw-normal">{t("Total Stake")} :</h6>
                        <h6>{history.stake.toLocaleString(undefined, { minimumFractionDigits: 2 })}</h6>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <h6 className="fw-normal">{t("Total Odds")} :</h6>
                        <h6>{history.totalOdds.toFixed(2)}</h6>
                      </div>
                    </div>
                    <StyledHistoryBottom className="bg-info pt-2 px-2 m-0">
                      {history.stakeTaxAmount > 0 &&
                        <div className="d-flex justify-content-between align-items-center">
                          <h6 className="fw-normal">
                            {t("Excise Tax")}
                            {/* ({history.stakeTaxPercentage || 0}%) */}
                          </h6>
                          <h6>
                            {history.rgsSession.currency}{" "}
                            {history.stakeTaxAmount.toLocaleString(undefined, { minimumFractionDigits: 2 }) || 0}
                          </h6>
                        </div>
                      }
                      {
                        history.winningsTaxAmount > 0 &&
                        <div className="d-flex justify-content-between align-items-center">
                          <h6 className="fw-normal">
                            {t("Withholding Tax")}
                            {/* ({history.winningsTaxPercentage || 0}%) */}
                          </h6>
                          <h6>
                            {history.rgsSession.currency}{" "}
                            {history.winningsTaxAmount.toLocaleString(undefined, { minimumFractionDigits: 2 }) || 0}
                          </h6>
                        </div>
                      }
                      <div className="d-flex justify-content-between align-items-center">
                        <h6 className="fw-normal">{t("Bonus")} ({history.bonusPercentage || 0}%)</h6>
                        <h6>
                          {history.rgsSession.currency}{" "}
                          {history.bonusAmount.toLocaleString(undefined, { minimumFractionDigits: 2 }) || 0}
                        </h6>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <h6 className="fw-normal">{(history.status === "OPEN") ? <span>{t("Possible Win")}</span> : <span>{t("Total Returns")}</span>}</h6>
                        <h6>
                          {history.rgsSession.currency}{" "}
                          {history.status === "LOST"
                            ? "0.00"
                            : history.finalReturnAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                        </h6>
                      </div>
                    </StyledHistoryBottom>
                  </div >
                </div >
                <div
                  className={`${collapse && index === selectIndex ? "d-block" : "d-none"
                    }`}
                >
                  <div className="fw-bold m-2">
                    <div>
                      {history.betType === "SUPER_ODDS" && "Super Odds"}
                    </div>
                    <div>
                      {(getResult(history.fkLeagueId))} {t("Season")} #{history.fkSeasonId},{" "}
                      <span>{t("Week")} {history.fkWeekId}</span>
                    </div>
                    <div>
                      {history.betType === "SUPER_ODDS" &&
                        history.selections.length > 0 ? (
                        <span>
                          {history.selections[0].gameName} -
                          {history.selections[0].outcomeDescription}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  {history?.betType === "SINGLE_BET" || history?.betType === "COMBO_BET" ? (
                    <React.Fragment>
                      {history?.selections?.map((selection, index) => (
                        <React.Fragment key={index}>
                          <BetSlipList selection={selection} />
                        </React.Fragment>
                      ))}
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      {history?.selections?.map((bet, index) => (
                        <React.Fragment key={index}>
                          {bet.selectedMarket?.selectedOutCome?.selections?.map(
                            (selection, index) => (
                              <React.Fragment key={index}>
                                <BetSlipList selection={selection} />
                              </React.Fragment>
                            )
                          )}
                        </React.Fragment>
                      ))}
                    </React.Fragment>
                  )}
                </div>
              </div >
            ))}
          </div >
          <div
            className={`text-center mb-2 fs-5 ${loadMoreShow ? "d-block" : "d-none"
              }`}
          >
            <span onClick={nextHistory} className="cursor">
              {t("Load More")}
            </span>
          </div>
        </React.Fragment >
      )}
    </React.Fragment >
  );
};
export default BetHistory;
